import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './shared/components/header/header.component';
import { LoaderComponent } from "./shared/components/loader/loader.component";
import { Observable } from 'rxjs';
import { LoadingService } from './shared/services/loading.service';
import { AsyncPipe } from '@angular/common';
import { ToastComponent } from './shared/components/toast/toast.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastComponent, LoaderComponent, AsyncPipe],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {

  loadingService = inject(LoadingService);

  title = 'traze-webshop';

  loading$: Observable<boolean>;

  constructor() {
    this.loading$ = this.loadingService.loading$;
  }
}
